import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_PAYMENT_NEW_RECORD, GET_PAYMENTMETHOD_RECORDS} from '../actions';

import {
    createPaymentItemNewRecordSuccess,
    createPaymentItemNewRecordError,
    getRecordsSuccess,
    getRecordsError,
} from './actions';
// eslint-disable-next-line
const getRecordListAsync = async (payload) => {
  const sendDate = new Date().getTime();
  let receiveDate = new Date().getTime();
  // eslint-disable-next-line
  const pageSize = 20;

        let recordAccountListReturned = []
        recordAccountListReturned.data = [];
        recordAccountListReturned.data.items = [];

        let item1 = [];
        item1.paymentmethodid = "1";
        item1.name = "Cash";
        item1.account = "Cash";
        item1.methodType = "Cash";
        item1.accesstype = "Restricted"
        recordAccountListReturned.data.items.push(item1);

        let item2 = [];
        item2.paymentmethodid = "2";
        item2.name = "Cheque";
        item2.account = "Cheque";
        item2.methodType = "Cheque";
        item2.accesstype = "Restricted"
        recordAccountListReturned.data.items.push(item2);

        let item3 = [];
        item3.paymentmethodid = "3";
        item3.name = "Invoice-Pay Later";
        item3.account = "Invoice-Pay Later";
        item3.methodType = "Invoice-Pay Later";
        item3.accesstype = "Restricted"
        recordAccountListReturned.data.items.push(item3);

        //const recordRemittanceListReturned = await axios.get("vocabularies?trashed=false&search_text=" + remittanceSearchText + "&page_number=" + payload.pageNumber);

        return {
          recordList: recordAccountListReturned,
          total_item_count: recordAccountListReturned.data.total_item_count,
          message: null,
          responseTime: ((receiveDate - sendDate) / 1000).toFixed(1),
        };
};

function* getRecordList({ payload }) {
  try {
    const pageSize = 20;
    const recordListReturned = yield call(getRecordListAsync, payload);
    if (!recordListReturned.message) {
      const recordListParam = {
        records: recordListReturned.recordList,
        pagination: {
          pageNumber: payload.pageNumber,
          pageSize,
          startIndex: (payload.pageNumber - 1) * pageSize + 1,
          totalItemCount: recordListReturned.total_item_count,
          totalPages: Math.ceil(recordListReturned.total_item_count / pageSize),
        },
        responseTime: recordListReturned.responseTime,
      };
      if (payload.searchInputName) {
        recordListParam.searchInputName = recordListReturned.recordList;
      }
      yield put(getRecordsSuccess(recordListParam));
    } else {
      yield put(getRecordsError(recordListReturned.message));
    }
  } catch (error) {
    yield put(getRecordsError(error));
  }
}


const CREATE_NEW_RECORD_ERROR = "New record success.";

const createPaymentItemNewRecordAsync = async (newRecord) => {

  try{
    if (newRecord.paymentId > 0)
    {
      const responseObject = await centralApiAxios.put("vocabularies?id="+ newRecord.paymentId, newRecord);

      return {
      newsItem: responseObject.data,
      paymentId: responseObject.data.paymentId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.paymentId > 0),
      message: ""
      };
    }
    else{
      const responseObject = await centralApiAxios.post("vocabularies?id="+ newRecord.paymentId, newRecord);

      return {
      newsItem: responseObject.data,
      paymentId: responseObject.data.paymentId,
      trashed : newRecord.trashed,
      isNewsItemCreate: !(newRecord.paymentId > 0),
      message: ""
      };
    }

  }
  catch (err) {
    // alert(err);
    return {
       message: CREATE_NEW_RECORD_ERROR,
    };
  }
};

function* createPaymentItemNewRecord({ payload }) {
     const { history } = payload;
    
    try {
      const resultReturned = yield call(createPaymentItemNewRecordAsync, payload.newRecord.paymentItemRecord);
      if (!resultReturned.message) {
        yield put(createPaymentItemNewRecordSuccess(resultReturned));
        if (resultReturned.isNewsItemCreate)
        {
          if (payload.newRecord.paymentItemRecord.IsCreateInvoiceOnly)
          {
            history.push("/app/invoice-details/"+payload.newRecord.paymentItemRecord.orderId+"/4");
          }
          else{
            history.push("/app/order-complete/"+payload.newRecord.paymentItemRecord.orderId);
          }
           
        }
        if (payload.newRecord.catalogItemRecord.trashed == true) {
          history.push("/app/RecordListing/Vocabularies");
          window.location.reload();
        }
        else{
          window.location.reload();
        }
      } else {
        yield put(createPaymentItemNewRecordError(resultReturned.message));
      }
    } catch (errorExp) {
      yield put(createPaymentItemNewRecordError(CREATE_NEW_RECORD_ERROR));
    }
}

export function* watchGetRecords() {
  yield takeEvery(GET_PAYMENTMETHOD_RECORDS, getRecordList);
}
// eslint-disable-next-line
export function* watchCreateRecords(newRecord) {
  yield takeEvery(CREATE_PAYMENT_NEW_RECORD, createPaymentItemNewRecord);
}

export default function* rootSaga() {
    yield all([
        fork(watchCreateRecords),
        fork(watchGetRecords)
    ]);
}
